<div mat-dialog-title>
  <span>{{'stations.configuredGraphs.modal.modalOrganize.title' | translate}}</span>
</div>
<div class="badge__ctn">
  <mat-dialog-content>
    <div class="desc">{{'stations.configuredGraphs.modal.modalOrganize.desc' | translate}}</div>
    <div class="graph-container-organize" cdkDropList (cdkDropListDropped)="onDrop($event)">
      <table class="tab-graph">
        <thead>
          <tr>
            <th>
              {{'stations.configuredGraphs.newGraph.name' | translate}}
            </th>
            <th>
              {{'menu.dashboard' | translate}}
            </th>
          </tr>
        </thead>
        <tbody>
          @for (item of graphs; track item; let index = $index) {
            <tr cdkDrag>
              <td class="graph-name" >{{ item.name }}</td>
              <td class="graph-check">
                @if (item.inDashboard) {
                  <span class="icon-checkbox" (click)="onCheckboxChange(index)">
                    <!-- <i title="Ajouter dans le Tableau de bord " class="fa-regular fa-square-check fa-lg" ></i> -->
                    <i class="fas fa-solid fa-check fa-lg"></i>
                  </span>
                }
                @if (!item.inDashboard) {
                  <span class="icon-checkbox" (click)="onCheckboxChange(index)">
                  </span>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </mat-dialog-content>
  <div mat-dialog-actions>
    <button class="btn btn--primary" type="submit" (click)="onSubmit()">{{'action.submit' | translate}}</button>
    <button mat-dialog-close
      class="btn btn--outline-grey-color ml-20">{{'action.cancel' | translate}}
    </button>
  </div>
</div>